var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 3.33301H8.125C5.47335 3.33301 4.14752 3.33301 3.32376 4.16985C2.5 5.00668 2.5 6.35355 2.5 9.04729V10.9521C2.5 13.6458 2.5 14.9927 3.32376 15.8295C4.14752 16.6663 5.47335 16.6663 8.125 16.6663H11.875C14.5267 16.6663 15.8525 16.6663 16.6762 15.8295C17.5 14.9927 17.5 13.6458 17.5 10.9521V9.04729C17.5 6.35355 17.5 5.00668 16.6762 4.16985C15.8525 3.33301 14.5267 3.33301 11.875 3.33301Z",
    stroke: "#192504",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 6.66699H8.33203",
    stroke: "#192504",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 13.333H14.1667C13.381 13.333 12.9882 13.333 12.7441 13.0889C12.5 12.8449 12.5 12.452 12.5 11.6663C12.5 10.8807 12.5 10.4878 12.7441 10.2438C12.9882 9.99967 13.381 9.99967 14.1667 9.99967H15.8333C16.619 9.99967 17.0118 9.99967 17.2559 10.2438C17.5 10.4878 17.5 10.8807 17.5 11.6663C17.5 12.452 17.5 12.8449 17.2559 13.0889C17.0118 13.333 16.619 13.333 15.8333 13.333Z",
    stroke: "#192504",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAlt);
export default __webpack_public_path__ + "static/media/Wallet_alt.0dad3cf1c4a8368b599e404247c56dd7.svg";
export { ForwardRef as ReactComponent };